import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Loader from "components/Loader";
import { Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "redux/actions/profile";
import * as actionTypes from "redux/constants";

const PatientContainer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile);
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    if (auth?.user?.role === actionTypes.SUPER_ADMIN || auth?.user?.role === actionTypes.BRAINBERRY_ADMIN) {
      dispatch(actions.getAllPatients());
    } else {
      dispatch(actions.getPatients(auth?.user?.email));
    }
  }, [dispatch]);

  const patients = profile.allPatients?.length > 0
    ? profile.allPatients
    : (profile.allProfiles?.patients || []);

  return (
    <Card sx={{ width: "100%" }}>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
        <MDBox display="flex" alignItems="center" gap={2}>
          <MDBox
            display="flex" justifyContent="center" alignItems="center"
            width="4rem" height="4rem" variant="gradient" bgColor="primary"
            color="white" shadow="md" borderRadius="xl"
          >
            <Icon fontSize="medium" color="inherit">person</Icon>
          </MDBox>
          <MDTypography variant="h5">Users / Patients</MDTypography>
        </MDBox>
        <MDButton color="primary" onClick={() => navigate("/users/patient/add-patient")}>
          + Add User
        </MDButton>
      </MDBox>

      <MDBox p={3}>
        {profile.loading ? (
          <Loader />
        ) : (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>Organisation</th>
              </tr>
            </thead>
            <tbody>
              {patients.map((pat, idx) => (
                <tr key={pat.userId ?? pat.id ?? idx}>
                  <td>{idx + 1}</td>
                  <td>{`${pat.firstName || pat.FirstName || ""} ${pat.lastName || pat.LastName || ""}`.trim() || "—"}</td>
                  <td>{pat.email || pat.Email || "—"}</td>
                  <td>{pat.organisationName || pat.OrganisationName || "—"}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        {!profile.loading && patients.length === 0 && (
          <p className="text-center p-5">No users found.</p>
        )}
      </MDBox>
    </Card>
  );
};

export default PatientContainer;
